// extracted by mini-css-extract-plugin
module.exports = {"tfa_header":"Header_tfa_header__vEC26","tfa_header__left":"Header_tfa_header__left__QtzsJ","tfa_header__left__logo":"Header_tfa_header__left__logo__PXefQ"};